<template>
  <div>
    <div>
      <div
        :class="['dropZone', dragging ? 'dropZone-over' : '']"
        @dragenter="dragging = true"
        @dragleave="dragging = false"
      >
        <div class="dropZone-info" @drag="onChange">
          <i class="fas fa-cloud-upload-alt"></i>&nbsp;
          <span class="dropZone-title">{{
            $lang.Drop_file_or_click_to_upload
          }}</span>
          <div class="dropZone-upload-limit-info">
            <div class="d-block d-md-flex justify-content-center">
              {{ $lang.maximum_file_size }} :&nbsp;
              <div v-for="(accept, key) in acceptFormats" :key="key">
                <span v-if="accept.caption"> {{ accept.caption }}</span>
                <span v-if="accept.value">
                  <strong> {{ accept.value }} </strong> </span
                >&nbsp;-&nbsp;
              </div>
            </div>
          </div>
        </div>
        <input
          type="file"
          ref="fileupload"
          :accept="acceptFormatsInput"
          @change="onChange"
          :multiple="multiple"
        />
      </div>
      <CropFile
        ref="cropComponent"
        :file="fileCropping"
        :aspectRatio="aspectRatio"
        :initialAspectRatio="initialAspectRatio"
        @save="createFile"
        @clearValue="clearValue"
      />

      <b-modal
        :title="modalTitle"
        header-bg-variant="danger"
        size="md"
        v-model="confirmModal"
      >
        <h6>{{ message }}</h6>
        <template v-slot:modal-footer>
          <b-button
            type="reset"
            class="ml-2"
            size="md"
            variant="danger"
            @click="cancelConfim"
          >
            {{ $lang.close }}
            <i class="fa fa-ban"></i>
          </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>
<script>
import CropFile from "./cropFile";
import { pathOr } from "ramda";

export default {
  name: "file-drag",
  components: {
    CropFile,
  },
  data() {
    return {
      dragging: false, // قبلیت درک
      fileCropping: null,
      confirmModal: false, // بازکردن مدال کانفرم
      modalTitle: "", // عنوان مدال
      message: "", // نمایش متن حذف فایل
    };
  },
  props: {
    // فایل‌های مورد قبول
    acceptFormats: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    crop: {
      type: Boolean,
      default: false,
    },
    acceptFormatsInput: {
      type: String,
      default: "",
    },
    maxUploadFile: {
      type: Number,
    },
    aspectRatio: {
      type: Number,
      default: null,
    },
    initialAspectRatio: {
      type: Number,
      default: null,
    },
  },
  methods: {
    pathOr,
    /**
     * @vuese
     * پاک کردن پیغام تایید پاک کردن
     *  @arg  بدون پارامتر
     */
    clearModalConfirm() {
      this.message = "";
      this.modalTitle = "";
    },
    /**
     * @vuese
     * لغو کردن فایل حذف شود
     *  @arg  بدون پارامتر
     */
    cancelConfim() {
      this.confirmModal = false;
      this.clearModalConfirm();
    },
    /**
     * @vuese
     * قبول کردن فایل حذف شود
     *  @arg  بدون پارامتر
     */
    async okConfim() {
      this.confirmModal = false;
      this.clearModalConfirm();
    },
    /**
     * @vuese
     * 	فایل‌های درک شده چک می شوند
     *  @arg  پارامتر ارایه فایل
     */
    onChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      const file = files[0];
      const isImage = ["png", "jpg", "jpeg"].some((item) =>
        file.type.match(item)
      );
      this.fileCropping = isImage && this.crop ? file : null;
      if (file.type.match("svg") || file.type.match("html")) {
        this.message = this.$lang.fileAccept;
        this.modalTitle = this.$lang.warning;
        this.confirmModal = true;
        this.dragging = false;
        return;
      }

      if (!files.length) {
        this.dragging = false;
        return;
      }
      if (isImage && this.crop) {
        this.$refs.cropComponent.view_crop = true;
        return;
      }

      this.createFile(files);
    },
    bytesToSize(bytes) {
      const sizes = ["بایت", "کیلوبایت", "مگابایت", "گیگابایت"];
      if (bytes == 0) return "0 بایت";
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
    /**
     * @vuese
     * 	ارسال فایل‌های درک شده
     *  @arg  پارامتر ارایه فایل
     */
    async createFile(files) {
      const file = pathOr(files, ["0"], files);
      const imageFile = pathOr(null, ["img"], file);
      const isImage = imageFile
        ? ["png", "jpg", "jpeg"].some((item) => imageFile.type.match(item))
        : false;
      this.file = this.crop == true && isImage ? [imageFile] : [file];
      this.dragging = false;
      const fileSize = this.file[0].size;
      const maxUploadFileSize = this.maxUploadFile * 1024;
      if (fileSize > maxUploadFileSize && isImage) {
        this.message = this.$lang.uploadImageLimitSize.replace(
          "{0}",
          this.bytesToSize(maxUploadFileSize)
        );
        this.modalTitle = this.$lang.warning;
        this.confirmModal = true;
        this.dragging = false;
        return;
      }
      this.$emit("uploadFile", this.file);
    },
    clearValue() {
      this.$refs.fileupload.value = "";
    },
  },
};
</script>
<style>
.dropZone {
  width: 100%;
  height: 80px;
  position: relative;
  border: 2px dashed #eee;
  margin-bottom: 1rem !important;
}

@media (max-width: 768px) {
  .dropZone {
    height: 160px;
  }
}

.dropZone:hover {
  border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
  color: #1975a0;
}

.dropZone-info {
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5c5c5c;
  opacity: 0.8;
}

.dropZone-uploaded {
  width: 100%;
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}
</style>
